import { useSelector } from 'react-redux';
import { useGetImageByIdQuery } from 'store/features/api/apiSlice';

function useGetImage(userId, size = 'original') {
	const companyCode = useSelector((state) => state.profile.profileData?.creatorOrganizationId);
	const { data, isSuccess, isLoading, isError } = useGetImageByIdQuery(
		{ userId, size, companyCode },
		{
			skip: userId && companyCode ? false : true,
		}
	);

	if (isSuccess && !isLoading) {
		if (data.modelEntity?.b64PicProfile) {
			let profile;

			try {
				profile = JSON.parse(data?.modelEntity?.b64PicProfile)?.[0]?.thumbUrl;
			} catch (error) {
				profile = data.modelEntity.b64PicProfile;
			}

			return {
				entityFullName: data.modelEntity.entityFullName,
				image: profile,
			};
		}
	}

	if (isError && !isLoading) {
		return null;
	}
}

export default useGetImage;
